/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementActionType } from './SupplementActionType';
import {
    SupplementActionTypeFromJSON,
    SupplementActionTypeFromJSONTyped,
    SupplementActionTypeToJSON,
    SupplementActionTypeToJSONTyped,
} from './SupplementActionType';
import type { JustificationSource } from './JustificationSource';
import {
    JustificationSourceFromJSON,
    JustificationSourceFromJSONTyped,
    JustificationSourceToJSON,
    JustificationSourceToJSONTyped,
} from './JustificationSource';

/**
 * Payload to update an existing supplement justification
 * @export
 * @interface UpdateSupplementJustificationRequest
 */
export interface UpdateSupplementJustificationRequest {
    /**
     * 
     * @type {SupplementActionType}
     * @memberof UpdateSupplementJustificationRequest
     */
    actionType?: SupplementActionType;
    /**
     * Amount requested for this justification in cents
     * @type {number}
     * @memberof UpdateSupplementJustificationRequest
     */
    amountRequestedCents?: number | null;
    /**
     * AI confidence score for this justification
     * @type {number}
     * @memberof UpdateSupplementJustificationRequest
     */
    confidenceScore?: number | null;
    /**
     * Justification text
     * @type {string}
     * @memberof UpdateSupplementJustificationRequest
     */
    justificationText?: string | null;
    /**
     * 
     * @type {JustificationSource}
     * @memberof UpdateSupplementJustificationRequest
     */
    justificationSource?: JustificationSource;
    /**
     * AI-generated reasoning for this justification
     * @type {string}
     * @memberof UpdateSupplementJustificationRequest
     */
    aiReasoning?: string | null;
    /**
     * Title of the codebook reference
     * @type {string}
     * @memberof UpdateSupplementJustificationRequest
     */
    codeBookTitle?: string | null;
    /**
     * Chapter within the codebook
     * @type {string}
     * @memberof UpdateSupplementJustificationRequest
     */
    chapter?: string | null;
    /**
     * Relevant snippet from the codebook
     * @type {string}
     * @memberof UpdateSupplementJustificationRequest
     */
    snippet?: string | null;
}



/**
 * Check if a given object implements the UpdateSupplementJustificationRequest interface.
 */
export function instanceOfUpdateSupplementJustificationRequest(value: object): value is UpdateSupplementJustificationRequest {
    return true;
}

export function UpdateSupplementJustificationRequestFromJSON(json: any): UpdateSupplementJustificationRequest {
    return UpdateSupplementJustificationRequestFromJSONTyped(json, false);
}

export function UpdateSupplementJustificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplementJustificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actionType': json['actionType'] == null ? undefined : SupplementActionTypeFromJSON(json['actionType']),
        'amountRequestedCents': json['amountRequestedCents'] == null ? undefined : json['amountRequestedCents'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'justificationText': json['justificationText'] == null ? undefined : json['justificationText'],
        'justificationSource': json['justificationSource'] == null ? undefined : JustificationSourceFromJSON(json['justificationSource']),
        'aiReasoning': json['aiReasoning'] == null ? undefined : json['aiReasoning'],
        'codeBookTitle': json['codeBookTitle'] == null ? undefined : json['codeBookTitle'],
        'chapter': json['chapter'] == null ? undefined : json['chapter'],
        'snippet': json['snippet'] == null ? undefined : json['snippet'],
    };
}

export function UpdateSupplementJustificationRequestToJSON(json: any): UpdateSupplementJustificationRequest {
    return UpdateSupplementJustificationRequestToJSONTyped(json, false);
}

export function UpdateSupplementJustificationRequestToJSONTyped(value?: UpdateSupplementJustificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionType': SupplementActionTypeToJSON(value['actionType']),
        'amountRequestedCents': value['amountRequestedCents'],
        'confidenceScore': value['confidenceScore'],
        'justificationText': value['justificationText'],
        'justificationSource': JustificationSourceToJSON(value['justificationSource']),
        'aiReasoning': value['aiReasoning'],
        'codeBookTitle': value['codeBookTitle'],
        'chapter': value['chapter'],
        'snippet': value['snippet'],
    };
}

